import { render, staticRenderFns } from "./SharedShortlistsProductSelection.vue?vue&type=template&id=6b362082&"
import script from "./SharedShortlistsProductSelection.vue?vue&type=script&lang=js&"
export * from "./SharedShortlistsProductSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports